import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=36ef9dab&"
import script from "./ConfigForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports